<template>
<pre v-html="code"></pre>  
</template>
<script>
import hljs from 'highlight.js'

export default {
  
    props: {
        attribute: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        code() {
            const urls = this.attribute.value.map((url) => {
                return `'${url}'`
            })
            
            return hljs.highlight(`
// VerifyCsrfToken.php    
protected $except = ${JSON.stringify(this.attribute.value, null, ' ')};
`, {language: 'php'}).value
        }
    }

}
</script>